import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-753645e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Booking Detail")
  ])
], -1))
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "#", -1))
const _hoisted_8 = { class: "col text-start" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Booking #", -1))
const _hoisted_10 = { class: "col text-start" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Start Time", -1))
const _hoisted_13 = { class: "col text-start" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "End Time", -1))
const _hoisted_15 = { class: "col text-start" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Booking fee", -1))
const _hoisted_18 = { class: "col text-start" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Total", -1))
const _hoisted_20 = { class: "col text-start" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Require Slot", -1))
const _hoisted_23 = { class: "col text-start" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, " Availabe Slot", -1))
const _hoisted_25 = { class: "col text-start" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Drivers /Accepted time", -1))
const _hoisted_28 = { class: "col text-start" }
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "User", -1))
const _hoisted_32 = { class: "col text-start" }
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "bussiness_name", -1))
const _hoisted_36 = { class: "col text-start" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "bussiness_name", -1))
const _hoisted_38 = { class: "col text-start" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "phone_number", -1))
const _hoisted_41 = { class: "col text-start" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "bussiness_address", -1))
const _hoisted_43 = { class: "col text-start" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "City ", -1))
const _hoisted_46 = { class: "col text-start" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Country ", -1))
const _hoisted_48 = { class: "col text-start" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Booking Status", -1))
const _hoisted_51 = { class: "col text-start" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { key: 3 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Payment method ", -1))
const _hoisted_57 = { class: "col text-start" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Booking Type", -1))
const _hoisted_60 = { class: "col text-start" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-start" }, "Created At", -1))
const _hoisted_64 = { class: "col text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString($setup.booking.id), 1),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString($setup.booking.booking_number), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString($options.dateTime($setup.booking.start_time)), 1),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString($options.dateTime($setup.booking.end_time)), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString($setup.booking.country?.currency_short_name) + " " + _toDisplayString($setup.booking.booking_fee), 1),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString($setup.booking.country?.currency_short_name) + " " + _toDisplayString($setup.booking.total), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString($setup.booking.number_of_rider), 1),
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString($setup.booking.available_slot), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.booking.booking_riders, (booking_rider) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: booking_rider.id
                }, [
                  _createElementVNode("a", {
                    href: `/drivers/${booking_rider.driver?.id}/detail`
                  }, _toDisplayString(booking_rider.driver.rider_name), 9, _hoisted_29),
                  _createTextVNode(" / " + _toDisplayString($options.dateTime(booking_rider.created_at)) + " ", 1),
                  _hoisted_30
                ]))
              }), 128))
            ]),
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("a", {
                href: `/users/${$setup.booking.user?.id}/view`
              }, _toDisplayString($setup.booking.user?.full_name), 9, _hoisted_33)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, _toDisplayString($setup.booking.bussiness_name), 1),
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, _toDisplayString($setup.booking.bussiness_name), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, _toDisplayString($setup.booking.phone_number), 1),
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, _toDisplayString($setup.booking.bussiness_address), 1)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, _toDisplayString($setup.booking.city?.name), 1),
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, _toDisplayString($setup.booking.country?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              _createTextVNode(_toDisplayString($setup.booking.booking_status) + " ", 1),
              ($setup.booking.booking_status === 'A')
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, " A "))
                : ($setup.booking.booking_status === 'B')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, " B "))
                  : ($setup.booking.booking_status === 'C')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, " C "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_55, " Not A/B/C "))
            ]),
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, _toDisplayString($setup.booking.paymentmethod?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("div", _hoisted_60, [
              ($setup.booking.booking_type==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, " Fixed "))
                : (_openBlock(), _createElementBlock("div", _hoisted_62, " Flexible "))
            ]),
            _hoisted_63,
            _createElementVNode("div", _hoisted_64, _toDisplayString($options.dateTime($setup.booking.created_at)), 1)
          ])
        ])
      ])
    ])
  ]))
}